import { ErrorModalProps } from '../../userVerificationModal.types';
import styles from '../../userVerificationModal.module.css';
import { Trans } from 'react-i18next';
import Button from '../../../button/button';
import { FC } from 'react';

export const VerificationErrorModalContent: FC<ErrorModalProps> = (
  props: ErrorModalProps,
) => (
  <div className={styles.content}>
    <h1 className={styles.error}>!</h1>
    <h3 className={styles.oops}>
      <Trans i18nKey={'userVerification.oops'} />
    </h3>
    <p className={styles.description}>
      <Trans i18nKey="userVerification.errorOccurred" />
    </p>
    <Button
      className={styles.okButton}
      onClick={props.handleVerificationErrorOk}
    >
      <Trans i18nKey="userVerification.ok" />
    </Button>
  </div>
);
